module.exports = __webpack_public_path__ + "img/eclipse.8329a5db.svg";